<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar :back="true" title="Accounts" :icon="require('@/assets/icon/accounts-active.svg')"
        @onBack="$navigationGoBack('/accounts')">
        <div class="options">
          <widgetButton @click="addUpdateForm()" :loading="false" class="btn-secondary">
            Add project +
          </widgetButton>
        </div>
      </WidgetToolbar>
    </div>
    <div class="page-tab">
      <div class="page-path-widget">
        <img @click="$router.push({ path: '/accounts' })" src="@/assets/icon/accounts-active.svg" class="icon" />
        <label @click="$router.push({ path: '/accounts' })" class="path-name link">Accounts</label>
        <img src="@/assets/icon/outline-carret-green.svg" class="allow" />
        <label class="path-name"> {{ account.name }} </label>
      </div>

      <div class="page-tab-options row">
        <widgetButton :loading="false" @click="getStartData(), getProjectsData()" class="btn-transparent fit-content">
          <img src="@/assets/icon/reflesh-gray.svg" />
        </widgetButton>
      </div>
    </div>
    <div class="page-body">
      <accountSidebar switch_tab="projects" :account="account"></accountSidebar>
      <div class="company-profile-wrapper">
        <!-- company-profile display -->
        <div class="company-profile-container" v-animate-css="'fadeIn'">
          <div class="items">
            <loading :height="25" color="#1ba5a4" :opacity="1" :width="25" :active.sync="isLoadingProjects"
              :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
            <div class="company-profile-body">
              <div class="project-widget" v-if="is_items_list_open">
                <!--  All Project list -->
                <ul class="project-items" v-if="projects.length > 0">
                  <li class="project-starter">
                    <div class="project-item-header">
                      <label>Projects</label>
                    </div>
                  </li>
                  <li class="project-item" :class="{ active: item.active }" v-for="(item, i) in projects" :key="i"
                    @click="viewItem(item)">
                    <div class="project-item-header">
                      <div class="project-item-brand">
                        <img src="@/assets/icons/project-icon.svg" />
                      </div>
                      <div class="content">
                        <div class="title-row">
                          <label>{{ item.name | validate }}</label>
                          <span class="locaction" v-if="item.address">{{
                            item.address | validate
                          }}</span>
                          <span class="locaction" v-else></span>
                          <span class="date">
                            <span v-if="item.from">{{
                              item.from | formatDate | validate
                            }}</span>
                            <span class="separator" v-if="item.from && item.to">-</span>
                            <span v-if="item.to">{{
                              item.to | formatDate | validate
                            }}</span>
                          </span>
                        </div>
                        <div class="options">
                          <div class="btns">
                            <dropdown-menu>
                              <ul>
                                <li>
                                  <a @click.prevent="editProject(item)" href>Edit Project</a>
                                </li>
                                <li>
                                  <app-dialog title="Delete Project"
                                    ask="Are you sure you want to permanently delete this project?" yesText="Delete"
                                    noText="Cancel" yesBtnClass="btn-danger" @onComfirm="deleteProject(item.id, i)">
                                    <a href="#">Delete Project</a>
                                  </app-dialog>
                                </li>
                              </ul>
                            </dropdown-menu>
                          </div>

                          <span v-if="item.verified" class="verified-status">Verified</span>
                          <!-- <button
                            v-if="options.expanded && !item.verified"
                            class="btn-verify"
                            @click="showVerifyForm(item.id)"
                          >
                            Verify project
                          </button> -->
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="empty-widget" v-else>
                  <div class="empty-widgetheader">
                    <label>Projects</label>
                  </div>
                  <div class="empty-widget-body">
                    <p>
                      You have not yet added projects yet,
                      <br />Click below to add one
                    </p>
                    <widgetButton @click="addUpdateForm()" :loading="false" class="btn-secondary">
                      Add project +
                    </widgetButton>
                  </div>
                </div>
              </div>

              <!-- Verify form -->
              <div class="verify-form" v-show="show_verify">
                <div class="project-form">
                  <div>
                    <h2 class="__green">Project Verification</h2>
                  </div>
                  <div class="__cardsss">
                    <div class="__box">
                      <div class="__row-1">
                        <span class="__label">Company Domain</span>
                      </div>
                      <div class="input-group">
                        <input type="text" v-model="request.domain" placeholder="E.g.  meritios.com" class />
                      </div>
                    </div>
                    <div class="__box">
                      <div class="__row-1">
                        <span class="__label">Company Email</span>
                      </div>
                      <div class="input-group">
                        <input type="text" v-model="request.email" placeholder="E.g.  johndoe@meritios.com" class />
                      </div>
                    </div>
                    <div class="__btns">
                      <consultfied-button :loading="verify_project_loading" @click="verifyProject()" class="save">Send a
                        request</consultfied-button>
                      <button class="cancel" @click="closeVerifyForm()">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="item-view-more" v-if="project_item">
            <div class="project-item">
              <div class="project-item-header">
                <div class="project-item-brand">
                  <img src="@/assets/icons/project-icon.svg" />
                </div>
                <div class="content">
                  <div class="title-row">
                    <label>{{ project_item.name | validate }}</label>
                    <span v-if="project_item.address">{{
                      project_item.address | validate
                    }}</span>

                    <span class="date">
                      <span v-if="project_item.from">{{
                        project_item.from | formatDate | validate
                      }}</span>
                      <span class="separator" v-if="project_item.from && project_item.to">-</span>
                      <span v-if="project_item.to">{{
                        project_item.to | formatDate | validate
                      }}</span>
                    </span>
                  </div>
                  <button class="close-btn" @click="showItemsList()">
                    <span>&times;</span>
                  </button>
                  <div class="options">
                    <div class="btns">
                      <dropdown-menu>
                        <ul>
                          <li>
                            <a @click.prevent="editProject(project_item)" href>Edit Project</a>
                          </li>
                          <li>
                            <app-dialog title="Delete Project"
                              ask="Are you sure you want to permanently delete this project?" yesText="Delete"
                              noText="Cancel" yesBtnClass="btn-danger" @onComfirm="deleteProject(project_item.id, i)">
                              <a href="#">Delete Project</a>
                            </app-dialog>
                          </li>
                        </ul>
                      </dropdown-menu>
                    </div>
                    <!-- <button
                          v-if="options.expanded && !project_item.verified"
                          class="btn-verify"
                          @click="showVerifyForm(project_item.id)"
                        >Verify project</button>-->
                  </div>
                </div>
              </div>
              <div class="project-item-body_">
                <div class="project-info">
                  <h5 v-if="project_item.description">Description</h5>
                  <div class="project-disc" v-html="project_item.description"></div>
                  <h5 v-if="project_item.members && project_item.members.length > 0
                    ">
                    Members
                  </h5>
                  <div class="collaboraters-widget" v-if="project_item.members && project_item.members.length > 0
                    ">
                    <div class="item" v-for="(item, i) in project_item.members" :key="i">
                      <img v-if="project_item.profile_picture" class="profile-img" :src="$fullUrl(
                        'images/profiles/' + project_item.profile_picture
                      )
                        " alt />
                      <img class="profile-img" v-else src="@/assets/icons/logo_avatar.svg" alt />
                      <span class="name">{{ project_item.first_name | validate }}
                        {{ project_item.last_name | validate }}</span>
                    </div>
                  </div>
                  <h5>Skills</h5>
                  <div class="skills-widget">
                    <div class="skills_content__wrapper">
                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Competences</label>
                        </div>
                        <div class="skill_box_body" v-if="project_item.skills.competences.length > 0">
                          <div class="row__item" v-for="(
                              value, i
                            ) in project_item.skills.competences.slice(0, 5)" :key="i">
                            <span>{{ value.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                              :show-rating="false" v-model="value.level"></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any competence yet.</p>
                          </div>
                        </div>
                      </div>
                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Tools</label>
                        </div>
                        <div class="skill_box_body" v-if="project_item.skills.tools.length > 0">
                          <div class="row__item" v-for="(
                              value, i
                            ) in project_item.skills.tools.slice(0, 5)" :key="i">
                            <span>{{ value.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                              :show-rating="false" v-model="value.level"></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any tool yet.</p>
                          </div>
                        </div>
                      </div>
                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Domains</label>
                        </div>
                        <div class="skill_box_body" v-if="project_item.skills.domains.length > 0">
                          <div class="row__item" v-for="(
                              value, i
                            ) in project_item.skills.domains.slice(0, 5)" :key="i">
                            <span>{{ value.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                              :show-rating="false" v-model="value.level"></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any domain yet.</p>
                          </div>
                        </div>
                      </div>

                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Roles</label>
                        </div>
                        <div class="skill_box_body" v-if="project_item.skills.roles.length > 0">
                          <div class="row__item" v-for="(
                              value, i
                            ) in project_item.skills.roles.slice(0, 5)" :key="i">
                            <span>{{ value.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                              :show-rating="false" v-model="value.level"></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any role yet.</p>
                          </div>
                        </div>
                      </div>
                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Languages</label>
                        </div>
                        <div class="skill_box_body" v-if="project_item.skills.languages.length > 0">
                          <div class="row__item" v-for="(
                              value, i
                            ) in project_item.skills.languages.slice(0, 5)" :key="i">
                            <span>{{ value.lang.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                              :show-rating="false" v-model="value.level"></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any language yet.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End -->

        <!-- Add and update form -->
        <addProjectModal v-if="add_update_form" :value="project_item" :account_name="account.name"
          :account_id="account.id" @close="add_update_form = false" @saved="projectSaved()">
        </addProjectModal>
      </div>
    </div>
  </div>
</template>

<script>
import appDialog from "@/components/Dialog/AppDialog.vue";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import { eventBus } from "@/main";
import moment from "moment";
import accountSidebar from "@/views/Accounts/components/account_sidebar.vue";
import addProjectModal from "./components/add_project_modal.vue";
export default {
  name: "projects",
  components: {
    appDialog,
    consultfiedButton,
    accountSidebar,
    addProjectModal,
  },
  props: {},
  data: () => {
    return {
      tab: "all",
      projects: [],
      add_update_form: false,
      is_items_list_open: true,
      show_verify: false,
      showAddProjectInviteModel: false,
      request: {
        domain: "",
        email: "",
      },
      envitation_project_loading: false,
      verify_project_loading: false,
      search_project_input: "",
      project_item: null,
      account: {},
      company_member_list: [],
      search_consultant_member: "",
      isLoadingProjects: false,
    };
  },
  mounted() {
    let vm = this;
    vm.getStartData();
  },
  computed: {},
  methods: {
    editProject(project) {
      this.project_item = project;
      this.add_update_form = true;
    },
    viewItem(item) {
      let vm = this;
      vm.projects.forEach((item) => {
        eventBus.$set(item, "active", false);
        return item;
      });
      item.active = true;
      vm.project_item = item;
    },
    getStartData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("ACCOUNT_SINGLE_GET_ALL_DATA", {
          account_id: vm.$route.params.id,
        })
        .then((responce) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.account = responce.data;
          vm.getProjectsData();
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    verifyProject(id) {
      let vm = this;
      vm.verify_project_loading = true;
      let domain = vm.request.email.replace(/.*@/, "");
      if (vm.request.domain.includes(domain)) {
        vm.$store
          .dispatch("VERIFY_PROJECT", vm.request)
          .then((responce) => {
            vm.closeVerifyForm();
            vm.verify_project_loading = false;
          })
          .catch((error) => {
            vm.verify_project_loading = false;
            console.log({
              error,
            });
          });
      } else {
        vm.$notify({
          group: "status",
          title: "Verification",
          text: "Enter a matching email and domain",
          type: "warn",
          duration: 3000,
        });
        vm.verify_project_loading = false;
      }
    },
    deleteProject(id, i) {
      let vm = this;
      vm.$store
        .dispatch("DELETE_PROJECT", {
          id: id,
        })
        .then((responce) => {
          if (i > -1) {
            vm.projects.splice(i, 1);
          }
          vm.project_item = null;
        })
        .catch((error) => {
          console.log({
            error,
          });
        });
    },
    getProjectsData() {
      let vm = this;
      vm.isLoadingProjects = true;
      vm.$store
        .dispatch("ACCOUNT_PROJECT_GET_ALL", {
          account_id: parseInt(vm.$route.params.id),
        })
        .then((responce) => {
          vm.projects = vm.processSkills(responce.data);
          if (window.innerWidth > 500) {
            if (vm.projects.length > 0) {
              vm.viewItem(vm.projects[0]);
            }
          }
          vm.isLoadingProjects = false;
        })
        .catch((error) => { });
    },
    processSkills(obj) {
      return obj.map((item) => {
        let skills = {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        };
        let skills_data = [];
        if (item.skills && item.skills.length > 0) {
          item.skills.forEach((skill) => {
            skill.tools.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.tools.push(obj);
            });
            skill.domains.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.domains.push(obj);
            });
            skill.competences.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.competences.push(obj);
            });
            skill.roles.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.roles.push(obj);
            });
            skill.languages.forEach((item) => {
              if (item.lang) {
                let obj = {
                  lang: { name: item.lang.name },
                  level: parseInt(item.level),
                };
                skills.languages.push(obj);
              }
            });
          });
        }
        eventBus.$set(item, "skills_data", item.skills);
        eventBus.$set(item, "skills", skills);

        return item;
      });
    },
    addUpdateForm() {
      let vm = this;
      vm.project_item = null;
      vm.add_update_form = true;
    },
    projectSaved() {
      let vm = this;
      vm.add_update_form = false;
      vm.getProjectsData();
    },
    showVerifyForm(id) {
      let vm = this;
      vm.show_verify = true;
      vm.is_items_list_open = false;
      eventBus.$set(vm.request, "project_id", id);
    },
    closeVerifyForm() {
      let vm = this;
      vm.show_verify = false;
      vm.is_items_list_open = true;
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 5px;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;

    .options {
      display: flex;
      align-items: center;

      .search-account {
        width: 250px;
        height: 45px;
      }

      .btn-add {
        margin-left: 20px;
        width: 130px;
      }
    }
  }

  .page-tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;

    .page-path-widget {
      display: flex;
      align-items: center;

      .icon {
        width: 15px;
        margin-top: -3px;
        margin-right: 10px;
        cursor: pointer;
      }

      .allow {
        margin: 0px 10px;
      }

      .path-name {
        color: #1ba5a4;
        font-size: 12px;

        &.link {
          cursor: pointer;
        }
      }
    }
  }

  .page-body {
    height: calc(100% - 73px);
    display: flex;

    .company-profile-wrapper {
      width: calc(100% - 135px);
      height: 100%;
      display: flex;
      flex-direction: column;

      .company-profile-container {
        width: 100%;
        display: flex;
        height: 100%;

        .items {
          height: 100%;
          width: calc(50% - 5px);
          overflow-y: auto;
          background: #ffffff;
          border-radius: 5px;
          position: relative;

          .company-profile-body {
            border-radius: 5px;
            margin-bottom: 20px;

            .project-widget {
              ul.project-items {
                padding: 10px;
                list-style: none;
                margin: 0px;

                .project-starter {
                  margin-bottom: 6px;

                  .project-item-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-bottom: 2px;

                    label {
                      color: #000000;
                      font-size: 13px;
                    }

                    .btn-add {
                      color: #1ba5a4;
                      border: none;
                      padding: 10px 10px;
                      font-size: 14px;
                      outline: none;
                      cursor: pointer;
                      font-style: italic;
                      background: transparent;
                    }
                  }

                  p {
                    color: #131313;
                  }
                }

                .project-item {
                  background: #f5f5f5;
                  border-radius: 10px;
                  margin-bottom: 10px;
                  position: relative;
                  cursor: pointer;

                  :hover {
                    background: rgb(248, 248, 248);
                    border-radius: 10px;
                    cursor: pointer;
                  }

                  &.active {
                    background: rgb(248, 248, 248);
                  }

                  .project-item-header {
                    display: grid;
                    padding: 10px 10px;
                    grid-template-columns: 50px calc(97% - 50px);
                    grid-column-gap: 8px;

                    @media (min-width: 300px) and (max-width: 630px) {
                      grid-template-columns: 100%;
                      grid-column-gap: 10px;
                      padding: 10px 12px;
                    }

                    .project-item-brand {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: 50px;
                      height: 50px;

                      img {
                        width: 50px;
                        height: 50px;
                        object-fit: contain;

                        @media (min-width: 300px) and (max-width: 630px) {
                          width: 33px;
                          height: 33px;
                        }
                      }
                    }

                    .content {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;

                      .title-row {
                        padding-right: 9px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;

                        label {
                          display: block;
                          font-size: 13px;
                          overflow: hidden;
                          text-decoration: none;
                          text-overflow: ellipsis;
                          white-space: nowrap;

                          @media (min-width: 300px) and (max-width: 630px) {
                            font-size: 12px;
                          }
                        }

                        span {
                          color: #808080;

                          font-size: 11px;

                          @media (min-width: 300px) and (max-width: 630px) {
                            font-size: 12px;
                          }
                        }

                        span.locaction {
                          font-size: 11px;
                        }

                        .date {
                          color: #808080;
                          display: flex;
                          justify-content: flex-start;
                          align-items: center;
                          margin-bottom: 0px;
                          font-size: 11px;

                          .separator {
                            margin: 0px 5px;
                            display: flex;
                            align-items: flex-start;
                          }

                          @media (min-width: 300px) and (max-width: 630px) {
                            font-size: 11px;
                          }
                        }
                      }

                      .options {
                        display: flex;
                        align-items: flex-end;
                        flex-direction: column;

                        .btns {
                          display: flex;
                          margin-top: -11px;
                          position: relative;
                          right: 1px;
                          top: 5px;
                        }

                        .verified-status {
                          color: #0590ab;
                          margin: 10px 0px;
                        }

                        .btn-verify {
                          height: 40px;
                          width: 100px;
                          outline: none;
                          color: #fff;
                          background-color: #1890a9;
                          border-radius: 5px;
                        }

                        .status {
                          color: #000;
                          font-size: 13px;
                        }

                        .toogle-panel-btn {
                          width: 15px;
                          padding: 0;
                          height: 22px;
                          font-size: 20px;
                          position: absolute;
                          bottom: 10px;
                          right: 3px;

                          @media (min-width: 300px) and (max-width: 630px) {
                            right: 10px;
                          }

                          img {
                            width: 14px;
                          }
                        }
                      }
                    }

                    .toogle-panel-btn {
                      padding: 1px 40px;
                      font-size: 30px;
                      background: transparent;
                      border: none;
                      outline: none;
                      cursor: pointer;
                      color: #ccc;
                    }
                  }
                }
              }

              .empty-widget {
                background: #fff;
                padding: 20px;

                .empty-widget-body {
                  height: 350px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-direction: column;

                  p {
                    text-align: center;
                    width: 270px;
                  }

                  .add-btn {
                    width: 180px;
                    height: 45px;
                    background: #1890a9 0% 0% no-repeat padding-box;
                    border-radius: 4px;
                    color: #fff;
                    outline: none;
                    margin-right: 20px;
                    display: center;
                    justify-content: center;
                  }
                }
              }
            }

            .verify-form {
              background: #fff;
              border-radius: 5px;
              padding: 20px;

              @media (min-width: 300px) and (max-width: 630px) {
                padding: 0px;
              }

              .project-form {
                background: #f5f5f5;
                padding: 20px;

                @media (min-width: 300px) and (max-width: 630px) {
                  padding-top: 18px;
                  padding-left: 11px;
                  padding-right: 11px;
                  padding-bottom: 39px;
                }
              }

              .__label {
                margin-bottom: 8px;
                display: block;
              }

              .input-group {
                display: grid;

                input {
                  width: 100%;
                  height: 40px;
                  background: #fff;
                  padding: 0px 13px;
                  border-radius: 5px;
                  outline: none;
                }
              }

              .__btns {
                display: flex;
                width: 30%;
                margin-top: 30px;
                justify-content: space-between;

                .cancel {
                  color: #1ba5a4;
                  cursor: pointer;
                  font-weight: normal;
                  height: 30px;
                  padding: 3px 20px;
                  font-size: 14px;
                }

                .save {
                  background: #1ba5a4;
                  color: #fff;
                  font-size: 14px;
                  font-weight: normal;
                  cursor: pointer;
                  border-radius: 5px;
                  height: 30px;
                  padding: 3px 10px;

                  &:disabled {
                    background: #8d8d8d;
                    opacity: 0.3;
                  }
                }
              }
            }
          }
        }

        .item-view-more {
          height: 100%;
          width: calc(50% - 5px);
          overflow-y: auto;
          background: #fff;
          border-radius: 5px;
          margin-left: 5px;

          @media (min-width: 300px) and (max-width: 630px) {
            position: fixed;
            top: 0px;
            left: 0px;
            right: 0px;
            bottom: 0px;
            z-index: 999999;
            display: flex;
            justify-content: center;
            padding-right: 0px;
            background: #f5f5f5;
          }

          .project-item {
            margin-bottom: 10px;
            position: relative;

            @media (min-width: 300px) and (max-width: 630px) {
              padding-top: 20px;
            }

            .project-item-header {
              display: grid;
              padding: 10px 10px;
              grid-template-columns: 50px calc(97% - 50px);
              grid-column-gap: 20px;

              @media (min-width: 300px) and (max-width: 630px) {
                grid-template-columns: 100%;
                grid-column-gap: 10px;
                padding: 10px 20px;
              }

              @media (min-width: 300px) and (max-width: 630px) {
                position: fixed;
                top: 0px;
                left: 0px;
                right: 0px;
                background: #fff;
              }

              .project-item-brand {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 60px;
                height: 60px;

                @media (min-width: 300px) and (max-width: 630px) {
                  width: 40px;
                  height: 40px;
                  display: none;
                }

                img {
                  width: 50px;
                  height: 50px;
                  object-fit: contain;

                  @media (min-width: 300px) and (max-width: 630px) {
                    width: 33px;
                    height: 33px;
                  }
                }
              }

              .content {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .title-row {
                  padding-right: 9px;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;

                  label {
                    display: block;
                    font-size: 12px;

                    color: #000;
                    margin-bottom: 1px;

                    @media (min-width: 300px) and (max-width: 630px) {
                      font-size: 12px;
                    }
                  }

                  span {
                    color: #808080;
                    font-size: 11px;

                    @media (min-width: 300px) and (max-width: 630px) {
                      font-size: 11px;
                    }
                  }

                  span.locaction {
                    font-size: 11px;
                  }

                  .date {
                    color: #808080;
                    font-size: 11px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-bottom: 0px;

                    .separator {
                      margin: 0px 5px;
                      display: flex;
                      align-items: flex-start;
                    }

                    @media (min-width: 300px) and (max-width: 630px) {
                      font-size: 11px;
                    }
                  }
                }

                .close-btn {
                  display: none;

                  @media (min-width: 300px) and (max-width: 630px) {
                    display: block;

                    span {
                      font-size: 24px;
                    }
                  }
                }

                .options {
                  display: flex;
                  align-items: flex-end;
                  flex-direction: column;
                  height: 50px;

                  @media (min-width: 300px) and (max-width: 630px) {
                    display: none;
                  }

                  .btns {
                    display: flex;
                    margin-top: -5px;
                  }

                  .verified-status {
                    color: #0590ab;
                    margin: 10px 0px;
                  }

                  .btn-verify {
                    height: 40px;
                    width: 100px;
                    outline: none;
                    color: #fff;
                    background-color: #1890a9;
                    border-radius: 5px;
                  }

                  .status {
                    color: #000;

                    font-size: 13px;
                  }

                  .toogle-panel-btn {
                    width: 19px;
                    padding: 0;
                    height: 22px;
                    font-size: 20px;
                    position: absolute;
                    bottom: 10px;
                    right: 3px;

                    img {
                      width: 15px;
                    }
                  }
                }
              }

              .toogle-panel-btn {
                padding: 1px 40px;
                font-size: 30px;
                background: transparent;
                border: none;
                outline: none;
                cursor: pointer;
                color: #ccc;
              }
            }

            .project-item-body_ {
              padding: 10px;

              .project-info {
                h5 {
                  text-align: left;
                  color: #6e6e6e;
                  font-size: 13px;
                  margin: 5px 0px;
                }

                .project-disc {
                  text-align: left;
                  color: #000;
                  font-size: 12px;

                  p {
                    margin: 0px !important;
                  }
                }

                .collaboraters-widget {
                  padding: 10px 0px;
                  display: flex;
                  flex-wrap: wrap;

                  .item {
                    background: #1ba5a4 0% 0% no-repeat padding-box;
                    border-radius: 20px;
                    display: flex;
                    align-items: center;
                    padding: 4px 4px;
                    margin-right: 8px;
                    margin-bottom: 8px;

                    .profile-img {
                      width: 26px;
                      height: 26px;
                      border-radius: 50%;
                      margin-right: 5px;
                    }

                    .name {
                      color: #fff;
                    }
                  }
                }

                .skills-widget {
                  .skills_content__wrapper {
                    display: grid;
                    grid-template-columns: calc(50% - 5px) calc(50% - 5px);
                    grid-column-gap: 10px;
                    margin-bottom: 10px;

                    @media (min-width: 300px) and (max-width: 630px) {
                      grid-template-columns: 1fr;
                    }

                    .skill_box {
                      min-width: 0;
                      display: flex;
                      flex-direction: column;
                      margin-bottom: 10px;
                      width: 100%;
                      background: #f3f3f3;
                      border-radius: 10px;

                      .skill_box_header {
                        height: 50px;
                        display: flex;
                        align-items: center;
                        justify-content: space-around;
                        padding: 0px 15px;

                        label {
                          color: #0884af;
                          width: 100%;
                          font-size: 13px;
                        }
                      }

                      .skill_box_body {
                        padding: 0px 15px;

                        .empty-skills {
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                          height: 69px;
                          justify-content: center;

                          p {
                            text-align: center;
                            margin-bottom: 20px;
                            color: #8d8d8d;
                          }

                          button {
                            width: 133px;
                            height: 36px;
                            background: #1890a9 0% 0% no-repeat padding-box;
                            border-radius: 5px;
                            color: #fff;
                          }
                        }

                        .row__item {
                          display: flex;
                          margin-bottom: 10px;
                          justify-content: space-between;
                          width: 100%;

                          span {
                            color: #000000;
                            font-weight: normal;
                            margin-top: 2px;
                            font-size: 12px;
                          }
                        }
                      }
                    }
                  }

                  .next_skills_content__wrapper {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    grid-column-gap: 10px;

                    @media (min-width: 300px) and (max-width: 630px) {
                      grid-template-columns: 1fr;
                    }

                    .skill_box {
                      min-width: 0;
                      display: flex;
                      flex-direction: column;
                      width: 100%;
                      background: #f3f3f3;
                      border-radius: 10px;
                      margin-bottom: 15px;

                      .skill_box_header {
                        height: 50px;
                        display: flex;
                        align-items: center;
                        justify-content: space-around;
                        padding: 0px 15px;

                        label {
                          color: #0884af;
                          width: 100%;
                          font-size: 15px;
                        }
                      }

                      .skill_box_body {
                        padding: 0px 15px;

                        .empty-skills {
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                          height: 69px;
                          justify-content: center;

                          p {
                            text-align: center;
                            margin-bottom: 20px;
                            color: #8d8d8d;
                          }

                          button {
                            width: 133px;
                            height: 36px;
                            background: #1890a9 0% 0% no-repeat padding-box;
                            border-radius: 5px;
                            color: #fff;
                          }
                        }

                        .row__item {
                          display: flex;
                          margin-bottom: 10px;
                          justify-content: space-between;
                          width: 100%;

                          span {
                            color: #000000;
                            font-weight: normal;
                            margin-top: 2px;
                            font-size: 14px;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      .information-container {
        background: #f5f5f5 0% 0% no-repeat padding-box;
        border-radius: 5px;
        padding: 40px;

        .information-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 20px;

          .information-brand {
            display: flex;
            align-items: center;
            justify-content: space-between;

            img {
              width: 100px;
              margin-right: 20px;
            }

            span {}
          }

          .information-options {
            .btn-edit-info {
              box-shadow: 0px 1px 3px #00000029;
              border: 1px solid #36adae;
              border-radius: 5px;
              color: #1885ad;
              padding: 10px 50px;
            }
          }
        }

        .information-body {
          padding: 20px;

          ul {
            margin-left: -38px;
            list-style: none;

            .information-item {
              margin-bottom: 30px;

              label {
                color: #808080;
              }

              p {
                color: #131313;
              }
            }
          }
        }
      }

      .form-overlay {
        position: fixed;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        z-index: 99999999999999;
        display: block;
        background: rgba(0, 0, 0, 0.5);
        overflow-y: auto;
        padding: 40px 0px;

        @media (min-width: 300px) and (max-width: 630px) {
          padding: 0px;
        }

        .add-update-form {
          background: #fff;
          padding: 20px;
          border-radius: 5px;
          margin: 0 auto;
          width: 750px;

          @media (min-width: 300px) and (max-width: 630px) {
            width: 100%;
            padding: 0px;
          }

          .form {
            background: #f7f7f7;
            padding: 20px;
            border-radius: 5px;

            h2 {
              font-family: "Nunito", sans-serif;
              font-size: 13px;
              font-weight: 900;
              font-stretch: normal;
              font-style: normal;
              line-height: 3.77;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
            }

            span {
              font-size: 14px;
              margin-left: 10px;
              margin-bottom: 10px;
              color: #646262;
            }

            .__row {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 15px;

              h2 {
                color: #000000;
                font-weight: normal;
                line-height: 0px;
                font-size: 22px;
              }

              button {
                background: transparent;
                outline: none;
                color: #680404;
                width: 94px;
                border-radius: 5px;
                border: 0.5px solid #7e0505;
                height: 27px;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                  margin-left: 20px;
                }
              }
            }

            .skills-input-widget {
              margin-bottom: 20px;
            }

            .form-group {
              display: grid;
              justify-content: space-between;
              grid-template-columns: 49% 49%;

              @media (min-width: 300px) and (max-width: 630px) {
                flex-direction: column;
                grid-template-columns: 100%;
              }

              .__box {
                width: 100%;
                display: flex;
                flex-direction: column;

                @media (min-width: 300px) and (max-width: 630px) {
                  max-width: 100%;
                  width: 100%;
                  margin-bottom: 10px;
                }

                span {
                  font-family: "Nunito", sans-serif;
                  font-size: 14px;
                  font-weight: 300;
                  font-stretch: normal;
                  font-style: normal;
                  letter-spacing: normal;
                  text-align: left;
                  color: #646262;

                  b {
                    font-weight: 900;
                    color: #0884af;
                  }
                }

                .grouped,
                input[type="text"],
                textarea,
                select {
                  background: #fff;
                  font-size: 14px;
                  resize: none;
                  display: flex;
                  margin-bottom: 20px;
                  justify-content: space-between;
                  width: 100%;
                  padding: 10px;
                  outline: none;
                  border-radius: 5px;
                  border: 1px solid #ddd;
                  color: #707070;

                  @media (min-width: 300px) and (max-width: 630px) {
                    margin-bottom: 4px;
                  }

                  .__date-field,
                  .__date-field2 {
                    background-color: #f4f4f4;
                    background-image: url($assets + "/icons/calendar__icon.svg");
                    background-repeat: no-repeat;
                    background-position: right;
                    width: 49%;
                    border-radius: 5px;
                    padding: 5px;
                    background-position-x: 96%;
                  }
                }

                .grouped {
                  padding: 5px 5px;
                }

                .disabling {
                  .__date-field2 {
                    opacity: 0.3;
                    background-color: #f4f4f4;
                    background-image: none;
                    background-repeat: no-repeat;
                    background-position: right;
                    width: 49%;
                    border-radius: 5px;
                    padding: 5px;
                  }
                }

                textarea {
                  height: 100px !important;
                }
              }
            }

            .__box {
              max-width: 100%;
              width: 100%;
              display: flex;
              flex-direction: column;

              .form-label {
                position: relative;

                .project-label-helper-widget {
                  position: absolute;
                  top: -9px;
                  right: -13px;
                }
              }

              span {
                font-family: "Nunito", sans-serif;
                font-size: 14px;
                font-weight: 300;
                font-stretch: normal;
                font-style: normal;
                letter-spacing: normal;
                text-align: left;
                color: #646262;

                b {
                  font-weight: 900;
                  color: #0884af;
                }
              }

              .grouped,
              input[type="text"],
              textarea,
              select {
                background: #fff;
                font-size: 13px;
                resize: none;
                display: flex;
                margin-bottom: 0px;
                justify-content: space-between;
                width: 100%;
                padding: 10px;
                outline: none;
                border-radius: 5px;
                border: 1px solid #ddd;
                color: #707070;
                height: 45px;

                .__date-field {
                  background: #f4f4f4;
                  width: 49%;
                  border-radius: 5px;
                  padding: 5px;
                }
              }

              textarea {
                height: 100px !important;
              }
            }

            .input__dropdown {
              margin-bottom: 20px;

              .dropdown__wrapper {
                .invite-widget {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;

                  .__textview {
                    width: 360px;
                  }

                  .btn-invite-via-email {
                    background: #1ba5a4;
                    color: #fff;
                    font-size: 14px;
                    font-weight: normal;
                    cursor: pointer;
                    border-radius: 5px;
                    height: 40px;
                    width: 160px;
                    padding: 3px 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;

                    .invite-email-help-widget {
                      position: absolute;
                      top: -16px;
                      right: -6px;
                    }
                  }
                }
              }
            }

            .__btns {
              display: flex;
              width: 30%;
              margin-top: 30px;
              justify-content: space-between;

              .btn-cancel {
                color: #1ba5a4;
                cursor: pointer;
                font-weight: normal;
                height: 40px;
                padding: 3px 20px;
                font-size: 14px;
                width: 100px;
              }

              .btn-save {
                background: #1ba5a4;
                color: #fff;
                font-size: 14px;
                font-weight: normal;
                cursor: pointer;
                border-radius: 5px;
                height: 40px;
                width: 100px;
                padding: 3px 10px;
                display: flex;
                justify-content: center;
                align-items: center;

                &:disabled {
                  background: #8d8d8d;
                  opacity: 0.3;
                }
              }
            }
          }
        }
      }
    }
  }
}

.input-flex {
  display: flex;
}
</style>

<style lang="scss">
.card__body {
  padding: 20px;
  z-index: 9999;
  width: 100%;

  .__layout {
    .div {
      label {
        opacity: 0.51;
        font-family: "Nunito", sans-serif;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        color: #161615;
      }

      input {
        height: 30px;
        width: 100%;
        background: #fff;
        font-size: 14px;
        font-weight: 300;
        padding: 0 10px;
        margin: 10px 0;
        outline: none !important;
        border: none !important;
        border-radius: 5px;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: normal;

        &:focus {
          border: none !important;
          outline: none !important;
        }

        &::placeholder {
          opacity: 0.5;
          font-style: italic;
        }
      }

      .msg {
        background: #fff;
        margin-top: 10px;
        border-radius: 5px;
        opacity: 0.68;
        padding: 10px;
        font-size: 13px;
        color: #676767;
      }
    }
  }

  .__cont {
    display: flex;
    flex-direction: column;

    .icons {
      display: flex;
      width: 100%;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 0.7px solid #a0a0a0;
      margin-top: 10px;

      div {
        margin-right: 10px;

        label {
          font-size: 12px;
          margin-right: 10px;
        }

        input {
          margin-top: 5px;
        }
      }
    }

    .body {
      padding: 20px;
      border-radius: 5px;
      background: #f4f4f4;
      border: 1px solid #707070;

      .template {
        width: 100%;
        background: #fff;
        box-shadow: 0 6px 5px rgba(0, 0, 0, 0.16);
        margin-right: 10px;

        button {
          height: 10px;
          font-size: 4px;
          outline: none;
          color: #fff;
          border: none;
          background: #0e9695;
        }

        .header {
          display: flex;
          width: 100%;

          .first {
            display: flex;
            padding-left: 10px;
            padding-right: 10px;
            flex-direction: column;

            img {
              width: 30px;
              height: 30px;
              border-radius: 100%;
            }

            h2 {
              font-size: 6px;
              margin-top: 10px;
            }
          }

          .second {
            background: #0075a0;
            display: flex;
            flex-grow: 1;
            justify-content: center;
            align-items: center;

            .titles {
              display: flex;
              color: #fff;
              width: 100%;
              justify-content: space-between;
              padding-left: 10px;
              padding-right: 10px;

              h2 {
                font-size: 4px;
              }

              button {
                height: 10px;
                font-size: 4px;
                outline: none;
                border: none;
                background: #0e9695;
              }
            }
          }
        }

        .contents {
          display: flex;
          width: 100%;

          span,
          p,
          button {
            font-size: 4px !important;
          }

          .left {
            width: 100px;
          }

          .right {
            flex-grow: 1;
          }
        }
      }
    }

    .actiond {
      margin-top: 10px;
      display: flex;

      button {
        background: #1890a9;
        color: #fff;
        border-radius: 5px;
        padding: 5px 10px;
        justify-content: space-between;
        align-items: center;
      }

      .cancel {
        background: transparent;
        color: #0590ab;
      }
    }
  }

  .__input {
    margin: 20px 0;
    width: 100%;

    span {
      color: #979797;
      font-size: 14px;
      font-weight: normal;
    }

    input {
      width: 100%;
      color: gray;
      font-size: 14px;
      height: 30px;
      outline: none;
      background: #e9ebed;
      border-radius: 3px;
      box-shadow: 0 5px 5px rgba(0, 0, 0, 0.16);
      padding: 2px 10px;
    }
  }

  .btns {
    display: flex;
    width: 50%;
    float: right;
    justify-content: space-between;

    .cancel {
      color: #1ba5a4;
      cursor: pointer;
      font-weight: normal;
      height: 22px;
      padding: 1px 20px;
      font-size: 14px;
    }

    .save {
      background: #1ba5a4;
      color: #fff;
      font-size: 14px;
      font-weight: normal;
      cursor: pointer;
      border-radius: 5px;
      height: 22px;
      padding: 1px 10px;
      display: flex;
      justify-content: center;
      align-items: center;

      &:disabled {
        background: #8d8d8d;
        opacity: 0.3;
      }
    }
  }

  .btns-2 {
    display: flex;
    float: right;
    margin-top: 20px;

    .save {
      width: 100px;
      height: 40px;
      font-size: 14px;
      outline: none;
      opacity: 0.97;
      border-radius: 0.6vh;
      font-family: "Nunito", sans-serif;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: linear-gradient(to right,
          #1d9694 0%,
          #199295 36%,
          #108798 68%,
          #01759e 98%,
          #00749f 100%);
    }

    .cancel {
      width: 100px;
      height: 40px;
      font-size: 14px;
      outline: none;
      opacity: 0.51;
      font-family: "Nunito", sans-serif;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #161615;
    }
  }

  .__body {
    background: #f0eaea;
    padding: 20px;

    .__rowed {
      display: flex;
      width: 100%;
      margin-bottom: 20px;
      justify-content: space-between;

      span {
        color: #646262;
        font-size: 12px;
      }

      input,
      select {
        background: #ffffff;
        border-radius: 5px;
        padding: 5px 10px;
        outline: none;
        width: 80%;
        font-size: 12px;
        color: #c4c4c4;
      }

      select {
        width: 30%;
      }

      img {
        cursor: pointer;
      }

      .img {
        max-width: 15px;
        max-height: 15px;
      }
    }
  }

  .__rowed {
    position: relative;
  }

  .dropdown__body {
    background: #fff !important;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    position: absolute;
    width: 80%;
    top: 30px;
    z-index: 10;

    .dropdown__item {
      display: flex;
      cursor: pointer;
      padding: 0px 15px 5px 15px;
      margin-top: 10px;
      border-bottom: 1px solid #e6e6e6;
      flex-direction: row;

      img {
        width: 19px;
        border-radius: 100px;
        height: 19px;
        margin-right: 8px;
      }

      .text {
        display: flex;
        color: #808080;
        margin-top: -3px;
        font-size: 8pt;
        flex-direction: column;

        .small {
          font-size: 6pt;
          font-weight: normal;
          margin-top: -2px;
        }
      }
    }
  }
}

.__date-field_input,
.__date-field_input2 {
  background-color: #f4f4f4;
}
</style>